import React from 'react';

import { Chip, Divider } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import InfoIcon from '@material-ui/icons/Info';
import { Trans, useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { CommaSeparator, GetFormat, getFrequency } from '../../../AppUtil/AppUtil';
import AmortizationTableComponent from '../../../Component/AmortizationTableComponent';
import { commonStyleForDetail } from '../../../Component/Common/CommonStyle';
import Loader from '../../../Component/Common/Loader';
import BaseField from '../../../Component/Common/Loans/Base';
import Session from '../../../Service/Session';
import useReviewLoan from '../../../hooks/useReviewLoan';
import qs from 'query-string';

import ReactTooltip from 'react-tooltip';
import { hot } from 'react-hot-loader';

const LOAN_STATES = window.AppConfig.LOAN_STATES;

const PAYMENT_STATUS = window.AppConfig.PAYMENT_STATUS;

const displayItem = {
	principal: 'Loan Amount',
	annual_rate: 'Interest Rate',
	no_of_installments: 'Number of Installments',
	lender_state: "Lender's Region ",
	additional_terms: 'Additional Terms & Conditions',
	id: 'Loan ID',
	reason: 'Loan Purpose',
	Collateral: 'Collateral'
};

function Review({ classes = '', currentUser = null, match }) {
	const { closeTable, openAmortizationScreen, state } = useReviewLoan();
	const { t } = useTranslation();

	const getFormattedValue = (type, value) => {
		if (type) {
			return type === 'principal' ? CommaSeparator(parseFloat(value).toFixed(2)) : value;
		} else {
			return 'None';
		}
	};

	const getQueryParams = () => {
		if (qs.parse(window.location.search)) {
			const { creator_name, acceptor_name, type, mode_payment, status, page, tab, userId } = qs.parse(
				window.location.search
			);

			return { creator_name, acceptor_name, type, mode_payment, status, page, tab, userId };
		}
	};

	if (state._openScreen === 'AMORTIZATION_TABLE') {
		return (
			<AmortizationTableComponent
				disbursalTypeACH={getQueryParams.mode_payment === 'ACH'}
				closeAmortizationTable={closeTable}
				currentUser={currentUser || Session.get('CURRENT_USER_INFO')}
				hideHeaderFooter
				table={state._loans?.installments}
				typeOfUser="LEND"
				type={getQueryParams().type}
			/>
		);
	} else {
		return (
			<section>
				<Container component="main" maxWidth="md">
					<div className={classes.root}>
						<Grid container id="reduce-width" justify="center" spacing={5}>
							<Grid id="shadow-round" item sm={8} xs={12}>
								<div
									style={{
										padding: '20px',
										background: 'white',
										display: 'flex',
										flexDirection: 'column',
										rowGap: '20px'
									}}>
									<div item sm={6} xs={12}>
										<Paper className="">
											<Typography component="h3" variant="h5">
												{state._loans !== null ? (
													<>
														<BaseField
															customContainerClass="base-flex-container"
															customHeadingClass="black-heading"
															customValueClass="light-blue bold"
															heading="To"
															value={getQueryParams().acceptor_name}
														/>

														<Divider className="mobile_divider fullw" variant="middle" />

														{/* {Object.keys(displayItem).map(key => (
														<BaseField
															customContainerClass="base-flex-container"
															customHeadingClass="black-heading"
															heading={displayItem[key]}
															value={state._loans[key] ? state._loans[key] : 'None'}
														/>
													))} */}

														{Object.keys(displayItem).map(key => {
															if (key === 'principal') {
																return (
																	<BaseField
																		customContainerClass="base-flex-container"
																		customHeadingClass="black-heading loan_amount_heading"
																		customValueClass="bold loan_amount"
																		heading={displayItem[key]}
																		value={CommaSeparator(
																			parseFloat(state._loans[key]).toFixed(2)
																		)}
																	/>
																);
															}

															if (key === 'annual_rate') {
																return (
																	<BaseField
																		customContainerClass="base-flex-container"
																		customHeadingClass="black-heading interest_rate_heading"
																		customValueClass="bold loan_amount"
																		heading={displayItem[key]}
																		value={state._loans[key] + '%'}
																	/>
																);
															}

															return (
																<BaseField
																	customContainerClass="base-flex-container"
																	customHeadingClass="black-heading"
																	heading={displayItem[key]}
																	value={
																		state._loans[key] ? state._loans[key] : 'None'
																	}
																/>
															);
														})}
													</>
												) : (
													<Loader />
												)}
											</Typography>
										</Paper>
									</div>
									<div>
										<Paper>
											<Typography component="h3" variant="h5">
												{state._loans !== null ? (
													<>
														<BaseField
															customContainerClass="base-flex-container"
															customHeadingClass="black-heading"
															customValueClass="light-blue bold"
															heading="From"
															value={getQueryParams().creator_name}
														/>

														<Divider className="mobile_divider fullw" variant="middle" />
														<BaseField
															customContainerClass="base-flex-container"
															customHeadingClass="black-heading"
															heading="Loan Type"
															value={state._loans.loan_type || 'None'}
														/>
														<BaseField
															customContainerClass="base-flex-container"
															customHeadingClass="black-heading"
															heading="Frequency"
															value={getFrequency(state._loans.frequency) || 'None'}
														/>

														<BaseField
															customContainerClass="base-flex-container"
															customHeadingClass="black-heading"
															heading="Status"
															value={(() => {
																if (
																	state._loans.state === LOAN_STATES.APPROVE ||
																	state._loans.state === LOAN_STATES.POST_MODIFIED ||
																	state._loans.state === LOAN_STATES.COMPLETED
																) {
																	return (
																		<Chip
																			label={t(
																				`loan_states.${state._loans.state}`
																			)}
																			size="small"
																			style={{
																				backgroundColor: '#27B88D',
																				color: 'black',

																				fontWeight: 'bolder',
																				fontSize: '12px',
																				padding: '2px'
																			}}
																		/>
																	);
																} else {
																	return (
																		<Chip
																			color="primary"
																			label={t(
																				`loan_states.${state._loans.state}`
																			)}
																			size="small"
																			style={{
																				backgroundColor: 'yellow',
																				color: 'black'
																			}}
																		/>
																	);
																}
															})()}
														/>

														<BaseField
															customContainerClass="base-flex-container"
															customHeadingClass="black-heading"
															heading="Loan Start Date"
															value={(() => {
																if (state._loans.disbursal_date) {
																	return GetFormat(state._loans.disbursal_date);
																} else {
																	return GetFormat(state._loans.start_date);
																}
															})()}
														/>

														<BaseField
															customContainerClass="base-flex-container"
															customHeadingClass="black-heading"
															heading="Loan End Date"
															value={GetFormat(state._loans.end_date)}
														/>

														{state._loans.state !== LOAN_STATES.COMPLETED && (
															<BaseField
																customContainerClass="base-flex-container"
																customHeadingClass="black-heading"
																heading="Next Payment Amount"
																value={(() => {
																	if (state._loans.next_installment_details) {
																		return CommaSeparator(
																			parseFloat(
																				state._loans.next_installment_details
																					.emi_amount
																			).toFixed(2)
																		);
																	} else {
																		return CommaSeparator(
																			parseFloat(state._loans.emi_amount).toFixed(
																				2
																			)
																		);
																	}
																})()}
															/>
														)}

														<ReactTooltip
															aria-haspopup="true"
															effect="solid"
															id="max-tooltip"
															place="top"
															role="max-tooltip">
															<Trans i18nKey="view_detail.tooltip_funding_status">
																Funds Transfer in Progress = The Lender will be
																transferring
																<br />
																the loan funds from their wallet to yours
																<br />
																Check/Cash = The Lender will be providing the
																<br />
																funds via cash or check on a specific date
																<br />
																Pending Loan Acceptance = The loan is awaiting
																<br />
																final approval by the other party
															</Trans>
														</ReactTooltip>

														<BaseField
															customContainerClass="base-flex-container"
															customHeadingClass="black-heading loan_funding_status_heading"
															customValueClass="btn-bottom"
															heading={
																<>
																	Loan Funding Status{' '}
																	<span
																		className="loan_funding_tooltip"
																		data-for="max-tooltip"
																		data-tip
																		id="max-tooltip">
																		<InfoIcon color="disabled" />
																	</span>
																</>
															}
															value={(() => {
																if (
																	state._loans.state === LOAN_STATES.COMPLETED ||
																	state._loans.state === LOAN_STATES.APPROVE
																) {
																	if (
																		getQueryParams().mode_payment === 'ACH' ||
																		getQueryParams().type === 'outgoing fund'
																	) {
																		return (
																			<Chip
																				label={t(
																					`payment_status.${PAYMENT_STATUS.COMPLETED}`
																				)}
																				size="small"
																				style={{
																					backgroundColor: '#27B88D',
																					color: 'black',

																					fontWeight: 'bolder',
																					fontSize: '12px',
																					padding: '2px'
																				}}
																			/>
																		);
																	} else if (
																		getQueryParams().mode_payment === 'OFFLINE'
																	) {
																		return (
																			<Chip
																				label={t(
																					`payment_status.${PAYMENT_STATUS.CHEQUE_CASH}`
																				)}
																				size="small"
																				style={{
																					backgroundColor: '#27B88D',
																					color: 'black',

																					fontWeight: 'bolder',
																					fontSize: '12px',
																					padding: '2px'
																				}}
																			/>
																		);
																	} else {
																		return (
																			<Chip
																				label="N/A"
																				size="small"
																				style={{
																					backgroundColor: '#27B88D',
																					color: 'black',

																					fontWeight: 'bolder',
																					fontSize: '12px',
																					padding: '2px'
																				}}
																			/>
																		);
																	}
																} else if (state._loans.state === LOAN_STATES.PENDING) {
																	return (
																		<Chip
																			color="primary"
																			label="Pending Loan Acceptance"
																			size="small"
																			style={{
																				backgroundColor: 'yellow',
																				color: 'black'
																			}}
																		/>
																	);
																} else {
																	if (getQueryParams().mode_payment === 'ACH') {
																		return (
																			<Chip
																				label={t(
																					`payment_status.${PAYMENT_STATUS.ACH}`
																				)}
																				size="small"
																				style={{
																					backgroundColor: '#27B88D',
																					color: 'black',

																					fontWeight: 'bolder',
																					fontSize: '12px',
																					padding: '2px'
																				}}
																			/>
																		);
																	} else if (
																		getQueryParams().mode_payment === 'OFFLINE'
																	) {
																		return (
																			<Chip
																				label={t(
																					`payment_status.${PAYMENT_STATUS.CHEQUE_CASH}`
																				)}
																				size="small"
																				style={{
																					backgroundColor: '#27B88D',
																					color: 'black',

																					fontWeight: 'bolder',
																					fontSize: '12px',
																					padding: '2px'
																				}}
																			/>
																		);
																	} else {
																		return (
																			<Chip
																				label="N/A"
																				size="small"
																				style={{
																					backgroundColor: '#27B88D',
																					color: 'black',

																					fontWeight: 'bolder',
																					fontSize: '12px',
																					padding: '2px'
																				}}
																			/>
																		);
																	}
																}
															})()}
														/>

														<BaseField
															customContainerClass="base-flex-container"
															customHeadingClass="black-heading"
															heading="Guarantor Name"
															value={state._loans.guarantor_details.name}
														/>
													</>
												) : (
													<Loader />
												)}
											</Typography>
										</Paper>
									</div>
									<Grid
										className="no-shadow"
										container
										id="reduce-width"
										justify="center"
										spacing={2}>
										<Grid id="shadow-round" item sm={8} spacing={2} xs={12}>
											<Button
												aria-label="add"
												fullWidth
												onClick={openAmortizationScreen}
												style={{
													backgroundColor: '#76c4ee',
													color: 'white'
												}}
												type="submit"
												variant="extended">
												View Amortization Table
											</Button>
											{match.path === '/admin/customer/review/loan/:id' && (
												<Button
													aria-label="add"
													fullWidth
													onClick={() => {
														const { userId, page, tab, status } = getQueryParams();
														if (userId && page && tab && status) {
															window.location.href = `/admin/customer/custom-view/${userId}?page=${page}&tab=${
																getQueryParams().tab
															}&status=${status}`;
														} else {
															window.history.back();
														}
													}}
													style={{
														backgroundColor: '#fff',
														color: '#000',
														marginTop: '20px',
														border: '2px solid #76c4ee'
													}}
													type="button"
													variant="extended">
													Back
												</Button>
											)}
										</Grid>
									</Grid>
								</div>
							</Grid>
						</Grid>
					</div>
				</Container>
			</section>
		);
	}
}

export default withRouter(hot(module)(withStyles(commonStyleForDetail)(Review)));
